import { createContext, useState, ReactNode } from "react";

interface ColorContextType {
  color: string;
  setColor: (color: string) => void;

  secondaryfedcolor: string;
  setsecondaryfedColor: (secondaryfedcolor: string) => void;

  elementfedcolor: string;
  setelementfedColor: (elementfedcolor: string) => void;

  fedPlatform_name: string;
  setFedPlatformName: (fedPlatform_name: string) => void;

  fedPlatform_logo: string;
  setFedPlatformLogo: (fedPlatform_logo: string) => void;

  menuItemNames: Array<MenuItem>;
  setMenuItemNames: (menuItemNames: MenuItem[]) => void;

  clearColorContext: () => void;
}

interface MenuItem {
  label: string;
  value: string;
  description: string;
}

interface ColorContextProviderProps {
  children: ReactNode; // Specify the type for children prop
}

export const ColorContext = createContext<ColorContextType | undefined>(
  undefined
);

export const ColorProvider = ({ children }: ColorContextProviderProps) => {
  const [color, setColor] = useState<string>("");
  const [secondaryfedcolor, setsecondaryfedColor] = useState<string>("");
  const [elementfedcolor, setelementfedColor] = useState<string>("");
  const [fedPlatform_name, setFedPlatformName] = useState<string>("");
  const [fedPlatform_logo, setFedPlatformLogo] = useState<string>("");
  const [menuItemNames, setMenuItemNames] = useState<MenuItem[]>([]);

  const clearColorContext = () => {
    setColor("");
    setsecondaryfedColor("");
    setelementfedColor("");
    setFedPlatformName("");
    setFedPlatformLogo("");
    setMenuItemNames([]);
  };

  return (
    <ColorContext.Provider
      value={{
        color,
        setColor,
        secondaryfedcolor,
        setsecondaryfedColor,
        elementfedcolor,
        setelementfedColor,
        fedPlatform_name,
        setFedPlatformName,
        fedPlatform_logo,
        setFedPlatformLogo,
        menuItemNames,
        setMenuItemNames,
        clearColorContext,
      }}
    >
      {children}
    </ColorContext.Provider>
  );
};
